module.exports = __webpack_public_path__ + "assets/measure_engine_hours.1d040538.svg";